import { render, staticRenderFns } from "./ProjectSettingsPublications.vue?vue&type=template&id=7c40a99a&scoped=true"
import script from "./ProjectSettingsPublications.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsPublications.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingsPublications.vue?vue&type=style&index=0&id=7c40a99a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c40a99a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c40a99a')) {
      api.createRecord('7c40a99a', component.options)
    } else {
      api.reload('7c40a99a', component.options)
    }
    module.hot.accept("./ProjectSettingsPublications.vue?vue&type=template&id=7c40a99a&scoped=true", function () {
      api.rerender('7c40a99a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/projects/ProjectSettingsPublications.vue"
export default component.exports